<template>
    <q-dialog ref="dialogRef" persistent square><!--  @hide="onDialogHide"  sans 'persistent' -->

        <q-card class="q-dialog-plugin">
            <q-card-section>
            <!-- <q-item>
                <q-item-section> -->
                    <q-item-label class="text-body1">Modification du Statut de la Course</q-item-label>
                    <q-item-label><small>Ref: {{ course.ref }}</small></q-item-label>
                <!-- </q-item-section>
            </q-item> -->
            </q-card-section>

            <q-card-section>
                Statut ciblé : <b :class="'text-uppercase text-'+courseStore().getStatusColor(status_skey)">{{ courseStore().getStatusLabel(status_skey) }}</b>
            </q-card-section>

            <q-card-section v-if="$_.size(colis_selector)">
<!-- COLIS SELECTED -->
                <p>
                    <small><i>Sélection des colis de la course affectés par ce même statut :</i></small>
                    <br/>
                    <q-toggle v-model="select_all" @update:model-value="v => { if(v){ model = model_base } else { model = [] } }"
                                label="sélection globale" color="positive" dense size="xs" />
                </p>

                <q-option-group v-model="model" :options="colis_selector" type="toggle" color="positive"
                                @update:model-value="v => { select_all = Boolean(v?.length == $_.size(model_base))  }">

                    <template v-slot:label="opt">
                        <div class="row items-center">
                            <q-btn v-if="! $_.includes(model, opt.value)" @click.stop="open(route('colis.show', opt.value))" icon="open_in_new" color="info" dense square flat size="sm" class="q-mr-xs">
                                <q-tooltip>Ouvre la page de ce colis dans un nouvel onglet pour pouvoir lui modifier également son statut</q-tooltip>
                            </q-btn>
                            <span :class="'text-'+(! $_.includes(model, opt.value) ? 'warning' : 'teal')">{{ opt.label }}</span>
                            <small v-if="!isProd || isMaster">&nbsp; - ID: {{ opt.value }}</small>
                        </div>
                    </template>
                </q-option-group>

                <MyAlert v-if="$_.size(model) < course.count_colis" class="q-mt-md q-ml--sm q-mr--sm">
                    <p>
                    <span v-if="$_.size(model) < (course.count_colis - 1)"><b>Vous avez désélectionné plusieurs colis...</b><br/>Veuillez vous rendre sur leurs pages respectives afin de leurs attribuer directement le statut approprié...</span>
                    <span v-else><b>Vous avez désélectionné un colis...</b><br/>Veuillez vous rendre sur sa page afin de lui attribuer directement le statut approprié...</span>
                    </p>
                    <p class="q-mb-none"><small>Utilisez le bouton <q-icon name="open_in_new" size="xs" />&nbsp;(ouvre un nouvel onglet)</small></p>
                    <!-- <br/>
                    <q-btn @click.stop="open(route('colis.index'))" icon="arrow_forward" dense square outline size="sm" /> -->
                </MyAlert>
            </q-card-section>

            <q-card-section class="q-mb-md">
<!-- COMMENT -->
                <q-input v-model="comment" type="textarea" rows="4" maxlength="240" counter
                        label="Ajouter un commentaire" hint="facultatif" />

            </q-card-section>

            <q-card-actions align="right">
                <q-btn color="warning" label="Annuler" @click="onDialogCancel" square />

                <q-btn color="positive" :label="setSignature ? 'Signatures' : 'Enregistrer'" @click="onOKClick" square outline no-caps />

            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { open } from "@helpers";
import { useDialogPluginComponent } from 'quasar'
import { ref/* , computed */ } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { courseStore } from "@stores";

const props = defineProps({
    course: Object,
    status_skey: String,
    setSignature: Boolean,
})

// defineEmits([
//   // REQUIRED; need to specify some events that your
//   // component will emit through useDialogPluginComponent()
//   ...useDialogPluginComponent.emits
// ])



let colis_selector = ref([])
let model_base = ref([])
let model = ref([])

let comment = ref('')

let select_all = ref(true)

onMounted(()=>{

    var colis_ids_array = _.map(props.course.colis, 'id')
    model_base.value    = colis_ids_array
    model.value         = colis_ids_array

    _.each(props.course.colis, c=>{

        colis_selector.value.push({label: `Colis: ${c.ref}`, value: c.id})

        // model_base.value.push(c.id)
        // model.value.push(c.id)
    })
})

// const dialogRef = ref(null)

const { dialogRef, onDialogOK, onDialogCancel/* , onDialogHide */ } = useDialogPluginComponent()
// dialogRef      - Vue ref to be applied to QDialog
// onDialogHide   - Function to be used as handler for @hide on QDialog
// onDialogOK     - Function to call to settle dialog with "ok" outcome
//                    example: onDialogOK() - no payload
//                    example: onDialogOK({ /*...*/ }) - with payload
// onDialogCancel - Function to call to settle dialog with "cancel" outcome

// this is part of our example (so not required)
function onOKClick () {
  // on OK, it is REQUIRED to
  // call onDialogOK (with optional payload)

//   onDialogOK(model.value)
  onDialogOK({colis_selected: model.value, comment: comment.value})

  // or with payload: onDialogOK({ ... })
  // ...and it will also hide the dialog automatically
}
</script>
